import { render, staticRenderFns } from "./Auth_Text.vue?vue&type=template&id=7ff00662&scoped=true&"
import script from "./Auth_Text.vue?vue&type=script&lang=js&"
export * from "./Auth_Text.vue?vue&type=script&lang=js&"
import style0 from "./Auth_Text.vue?vue&type=style&index=0&id=7ff00662&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff00662",
  null
  
)

export default component.exports